/// <amd-module name="Core/Medius.Core.Web/Scripts/Bifrost/embedding"/>

export const getEmbeddableUrlIfNeeded = (prefix: string) => {
    const currentUrl = window.location.href;
    if (currentUrl.includes("SupplierInvoicesInboxLegacy")) {
        return "SupplierInvoicesInboxLegacy" + prefix;
    }
    else if (currentUrl.includes("SupplierInvoicesInbox")){
        return "SupplierInvoicesInbox" + prefix;
    }
    return prefix;
};
